import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  deleteWarranty,
  getWarranty,
  getWarrantyList,
} from "./WarrantyReducer";
import { WarrantyList } from "Shared/Types/fleetmanagementapi";
import { IWarrantyDetail } from "Shared/Types/warranty";
import { getFields } from "Components/WarrantyDetail/warrantyConstants";

interface InitialState {
  error?: string | null;
  loading: boolean;
  isFuncLoading: boolean;
  isFuncDeleteCommentLoading: boolean;
  success?: boolean | null;
  numPage: number;
  warranty: IWarrantyDetail;
  warrantyList: WarrantyList[];
  warrantyFiles: File[];
}

const initialState: InitialState = {
  loading: false,
  isFuncLoading: false,
  isFuncDeleteCommentLoading: false,
  error: null,
  numPage: 0,
  warrantyList: [],
  warranty: {
    currentWarranty: null,
    loading: false,
  },
  warrantyFiles: [],
};

const warrantySlice = createSlice({
  name: "warranty",
  initialState,
  reducers: {
    clear(state) {
      state.error = null;
      state.loading = false;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWarranty.pending, (state) => {
        state.warranty.loading = true;
        state.error = null;
      })
      .addCase(getWarranty.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.warranty.currentWarranty = action.payload;
      })
      .addCase(getWarranty.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });

    builder.addCase(getWarrantyList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.warrantyList = action.payload.results;
      state.numPage = action.payload.count;
    });
    builder.addCase(getWarrantyList.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(getWarrantyList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export const { clear } = warrantySlice.actions;

export const selectWarrantyList = (state: RootState) =>
  state.warranty.warrantyList;
export const selectWarrantyNumPage = (state: RootState) =>
  state.warranty.numPage;

export const selectWarranty = (state: RootState) => state.warranty.warranty;
export const selectWarrantyLoading = (state: RootState) =>
  state.warranty.loading;
export const selectWarrantyIsFuncLoading = (state: RootState) =>
  state.warranty.isFuncLoading;

export const warrantyDetailFields = (state: RootState) => {
  const fields = state.warranty.warranty.currentWarranty;
  return getFields(fields);
};

export default warrantySlice;
